export default __webpack_public_path__ + "static/media/vhLogoLarge.05d9b892.svg";